import {Stack, Button} from '@mui/material';

export interface MonthlyAnnualSelectorProps {
  isMonthly: boolean;
  setIsMonthly: (isMonthly: boolean) => void;
}

export default function MonthlyAnnualSelector({isMonthly, setIsMonthly}: MonthlyAnnualSelectorProps) {
  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{mb: 4}}>
      <Button size="small" variant={isMonthly ? 'contained' : 'outlined'} onClick={() => setIsMonthly(true)}>
        Monthly
      </Button>
      <Button size="small" variant={!isMonthly ? 'contained' : 'outlined'} onClick={() => setIsMonthly(false)}>
        Annual
      </Button>
    </Stack>
  );
}
